import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import App from "./App";
import "./index.css";
import "./utils/resizeObserver";

declare global {
  interface Window {
    deferredInstallPrompt?: BeforeInstallPromptEvent;
  }

  interface Navigator {
    standalone?: boolean;
  }

  interface BeforeInstallPromptEvent extends Event {
    prompt: () => Promise<void>;
    userChoice: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>;
  }
}

const queryClient = new QueryClient();

const isStandaloneApp = window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

if (isStandaloneApp && window.location.pathname === "/") {
  window.history.replaceState(null, "", "/integrador/dashboard");
}

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  window.deferredInstallPrompt = event as BeforeInstallPromptEvent;
  window.dispatchEvent(new Event("integrator-install-prompt-ready"));
});

window.addEventListener("appinstalled", () => {
  window.deferredInstallPrompt = undefined;
});

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

const isLocalHost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
const canRegisterServiceWorker = "serviceWorker" in navigator && process.env.NODE_ENV === "production" && !isLocalHost;

if (isLocalHost && "serviceWorker" in navigator) {
  // Do not let a stale local PWA worker intercept client-side routes while
  // the app is being tested from localhost.
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
}

if (canRegisterServiceWorker) {
  let reloadingForServiceWorkerUpdate = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloadingForServiceWorkerUpdate) return;
    reloadingForServiceWorkerUpdate = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .then((registration) => registration.update())
      .catch((error) => {
        console.error("Erro ao registrar service worker", error);
      });
  });
}
